"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _setValue = _interopRequireDefault(require("./setValue"));

var _shouldDangerouslyUpdateParcelData = _interopRequireDefault(require("./shouldDangerouslyUpdateParcelData"));

var _ValidateValueUpdater = _interopRequireDefault(require("../util/ValidateValueUpdater"));

var _default = function _default(updater) {
  return (0, _shouldDangerouslyUpdateParcelData.default)(updater) ? updater : function (parcelData, changeRequest) {
    var value = parcelData.value;
    var updatedValue = updater(value, changeRequest);
    (0, _ValidateValueUpdater.default)(value, updatedValue);
    return (0, _setValue.default)(updatedValue)(parcelData);
  };
};

exports.default = _default;